import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default () => {
	return useFeatureAvailable(Feature.PROJECT_PLAN);
};
